<template>
  <div id="app">
    <div class="navbar has-shadow">
      <div class="container">
        <div class="navbar-brand">


          <div class="navbar-burger burger" data-target="mainMenu" v-on:click="toggleBurger" v-bind:class="{ 'is-active':isActive }">
            <span></span>
            <span></span>
            <span></span>
          </div>

        </div>

        <div class="navbar-menu" id="mainMenu" v-bind:class="{ 'is-active':isActive }">
          <div class="navbar-end">
            <router-link to="/" class="navbar-item r-item">STATS50@TCD</router-link>
            <router-link to="isa" class="navbar-item r-item">ISA short course</router-link>
            <router-link to="gallery" class="navbar-item r-item">Gallery</router-link>
          </div>
        </div>
      </div>
    </div>

    <router-view></router-view>

    <footer class="footer is-primary">
      <div class="container">
        <div class="columns">
          <div class="column">
            <p>Contacts: <a href="mailto:arwhite@tcd.ie">Arthur White</a>, <a href="mailto:wyseja@tcd.ie">Jason Wyse</a></p>
          </div>
          <div class="column copyr has-text-centered">
            <p>
              copyright @2017 <a href="http://www.bernardonipoti.com/" target="_blank">Bernardo Nipoti</a>
            </p>
            <p>
              developed by <a href="http://sanvisimo.it" target="_blank">sanvisimo</a>
            </p>
          </div>
          <div class="column has-text-right">
            <a class="logo" href="https://www.tcd.ie/" target="_blank"><img src="./assets/trinity-common-use-white.png" alt="TCD" /></a>
          </div>
        </div>

      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'app',
  data: function(){
      return {
          isActive: false
      }
  },
  methods: {
      toggleBurger: function(){
          this.isActive = !this.isActive;
      }
  }
}
</script>

<style lang="sass">
@import "../node_modules/bulma/bulma.sass"
@import "mq"

body, card.subtitle, .subtitle
  font-size: 1.15rem

.navbar
  background-color: #383838
  position: fixed
  z-index: 99999
  width: 100%

  a:hover
    color: gray

.navbar-brand
  a
    color: #fff
    font-weight: bold

.hero
  padding-top: 50px


a
  color: $primary

a.r-item
  color: #C1C1C1
  padding: 0.5rem 1.75rem
  +mobile
    color: gray
    &:hover
      background-color: #F1F1F1


.navbar-burger span
  background-color: #C1C1C1

.is-primary
  background-color: $primary !important
  color: #fff

  a
    color: #fff

footer
  padding: 2rem 1.5rem !important

  p
    padding: 2rem 0 0

  a
    color: #000 !important

  section
    text-align: center

  .logo
    width: 200px

</style>



// WEBPACK FOOTER //
// src/App.vue?540a7b1b